module.exports = __webpack_public_path__ + "static/our-partners-img-29d42ebef3fded1060d4254ba884760b.svg";